import { HttpError as Image } from '../../Assets/images/svg';
import * as React from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Text } from 'ilenia';

export const HttpError: React.SFC<{}> = () => {
    return (
        <div className={css(styles.box)}>
            <div className={css(styles.imageWrapper)}>
                <Image/>
            </div>
            <div className={css(styles.messageWrapper)}>
                <div className={css(styles.title)}>
                    <Text id="httpError.title"/>
                </div>
                <div className={css(styles.message)}>
                    <Text id="httpError.message"/>
                </div>
            </div>
        </div>
    );
};

const styles = StyleSheet.create({
    box: {
        background: '#fff',
        borderRadius: '5px',
        border: '1px solid rgb(223, 226, 229)',
        height: '324px',
        width: '840px',
        margin: '32px auto',
    },
    imageWrapper: {
        margin: '48px auto 0',
        width: '180px',
    },
    messageWrapper: {
        marginTop: '24px',
        fontFamily: 'Lato',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    title: {
        color: 'rgb(33, 43, 54)',
        fontFamily: 'Lato',
        fontSize: '20px',
        fontWeight: 'bold',
        height: '28px',
        letterSpacing: '0px',
        lineHeight: '28px',
        width: '492px',
    },
    message: {
        color: 'rgb(83, 83, 83)',
        fontSize: '14px',
        height: '20px',
        letterSpacing: '0px',
        lineHeight: '20px',
        textAlign: 'center',
        width: '401px',
        marginTop: '16px',
    },
});
